import React, { useContext, useState, useEffect } from "react";
import { Store } from "../Store";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import NumberFormat from "../component/NumberFormat";
import MessageBox from "../component/MessageBox";

export default function OrderScreen() {
  const { state, dispatch  } = useContext(Store);
  const navigate = useNavigate();

  // Get successorders from Store or fallback to localStorage
const localOrders = (() => {
  try {
    const stored = JSON.parse(localStorage.getItem("successorders"));
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
})();
const [orders, setOrders] = useState(localOrders);

useEffect(() => {
  const updatedOrders = Array.isArray(state.successorders)
    ? state.successorders
    : JSON.parse(localStorage.getItem("successorders")) || [];
  setOrders(updatedOrders);
}, [state.successorders]);



  if (!orders || orders.length === 0) {
    return <MessageBox>No order found.</MessageBox>;
  }

  // Group by booking number
  const grouped = orders.reduce((acc, cur) => {
    acc[cur.BknghRefNo] = acc[cur.BknghRefNo] || [];
    acc[cur.BknghRefNo].push(cur);
    return acc;
  }, {});

    const handleNewOrder = () => {
    dispatch({ type: 'CLEAR_SUCCESS_ORDERS' }); // clear old orders
    navigate('/customer'); // go to start of new order
  };
  return (
    <div>
      <Button type="button" onClick={handleNewOrder} className="mb-3">
        
        New Order
      </Button>

      <h6 className="my-3" style={{ color: "green" }}>
        Orders successfully created! 👍
      </h6>

      <h6>Customer Name: {orders[0].CsName}</h6>
      <p>{orders[0].CsAddrs}</p>

      {Object.keys(grouped).map((bkngNo) => (
        <Card key={bkngNo} className="mb-3">
          <Card.Body>
            <h6 style={{ color: "green" }}>
             {bkngNo} -{" "}
              {new Date(grouped[bkngNo][0].BknghRefDate).toLocaleString("en-GB", {
                timeZone: "UTC",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              })}
            </h6>

            <Row className="align-items-center fw-bold">
              <Col xs={3}>Item</Col>
              <Col xs={3}>Quantity</Col>
              <Col xs={3}>Rate</Col>
              <Col xs={3}>Amount</Col>
            </Row>

            {grouped[bkngNo].map((item, i) => (
              <Row key={i} className="align-items-center">
                <Col xs={3}>{item.ItemDesc}</Col>
                <Col xs={3}>
                  <NumberFormat value={item.BkngdQnty} decimal={2} />
                </Col>
                <Col xs={3}>
                  <NumberFormat value={item.BkngdTpRate} decimal={2} />
                </Col>
                <Col xs={3}>
                  <NumberFormat value={item.BkngdAmnt} decimal={2} />
                </Col>
              </Row>
            ))}
          </Card.Body>
        </Card>
      ))}
    </div>
  );
}
